var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path6, _path7, _path8, _path9, _path0, _rect7, _line, _line2, _line3, _line4, _rect8, _rect9, _circle, _circle2, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileDesktopStatsNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.4375 237.498L100.805 247.863H111.703L102.887 254.269L106.254 264.633L97.4375 258.228L88.6207 264.633L91.9884 254.269L83.1717 247.863H94.0698L97.4375 237.498Z",
    fill: "#F58120"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.438 237.498L140.805 247.863H151.703L142.887 254.269L146.254 264.633L137.438 258.228L128.621 264.633L131.988 254.269L123.172 247.863H134.07L137.438 237.498Z",
    fill: "#F58120"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177.438 237.498L180.805 247.863H191.703L182.887 254.269L186.254 264.633L177.438 258.228L168.621 264.633L171.988 254.269L163.172 247.863H174.07L177.438 237.498Z",
    fill: "#F58120"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M217.438 237.498L220.805 247.863H231.703L222.887 254.269L226.254 264.633L217.438 258.228L208.621 264.633L211.988 254.269L203.172 247.863H214.07L217.438 237.498Z",
    fill: "#F58120"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M257.438 237.498L260.805 247.863H271.703L262.887 254.269L266.254 264.633L257.438 258.228L248.621 264.633L251.988 254.269L243.172 247.863H254.07L257.438 237.498Z",
    fill: "#F58120"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83.4375,
    y: 79.498,
    width: 204,
    height: 131,
    stroke: "#192657",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 137.438,
    y: 211.498,
    width: 95,
    height: 15,
    fill: "#192657"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 122.438,
    y: 102.498,
    width: 15,
    height: 15,
    fill: "#F58120"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 122.438,
    y: 126.498,
    width: 15,
    height: 15,
    fill: "#F58120"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 122.438,
    y: 150.498,
    width: 15,
    height: 15,
    fill: "#F58120"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 122.438,
    y: 174.498,
    width: 15,
    height: 15,
    fill: "#F58120"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M282.938 206.498V83.998C228.938 103.998 277.115 154.699 236.438 185.498C201.438 211.998 171.771 199.831 170.438 206.498H282.938Z",
    fill: "#192657"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.438 107.998L131.438 113.998C133.104 110.665 137.738 103.298 142.938 100.498",
    stroke: "#192657",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M125.438 130.998L131.438 136.998C133.104 133.665 137.738 126.298 142.938 123.498",
    stroke: "#192657",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M125.438 153.998L131.438 159.998C133.104 156.665 137.738 149.298 142.938 146.498",
    stroke: "#192657",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M125.438 176.998L131.438 182.998C133.104 179.665 137.738 172.298 142.938 169.498",
    stroke: "#192657",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 152.438,
    y: 102.498,
    width: 105,
    height: 87,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 162.438,
    y1: 109.498,
    x2: 232.438,
    y2: 109.498,
    stroke: "#192657",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 162.438,
    y1: 134.498,
    x2: 204.438,
    y2: 134.498,
    stroke: "#192657",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 162.438,
    y1: 159.498,
    x2: 217.438,
    y2: 159.498,
    stroke: "#192657",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 162.438,
    y1: 183.498,
    x2: 232.438,
    y2: 183.498,
    stroke: "#192657",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 54.4375,
    y: 63.498,
    width: 7,
    height: 67,
    fill: "#528FF5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4375,
    y: 104.498,
    width: 5,
    height: 36,
    fill: "#528FF5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 293.938,
    cy: 186.998,
    r: 21.5,
    fill: "#528FF5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.938,
    cy: 126.998,
    r: 13.5,
    stroke: "#F58120",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M166.939 58.9982C115.106 49.9982 16.239 66.7982 35.439 205.998C59.439 379.998 183.938 262.998 220.938 234.498C257.938 205.998 323.938 256.998 272.438 287.498C220.938 317.998 221.438 249.498 272.438 181.998C323.438 114.498 244.938 47.998 220.938 100.498",
    stroke: "black",
    strokeDasharray: "2 2 2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDesktopStatsNew);
export default __webpack_public_path__ + "static/media/MobileDesktopStatsNew.73df4516f27dfe7cdcb1a70a8458f222.svg";
export { ForwardRef as ReactComponent };